import { Transform, findWrapping } from "prosemirror-transform";
import type { Node as PMNode, NodeRange, Schema } from "prosemirror-model";

const wrapProsemirrorCardContainer = (doc: PMNode, schema: Schema): PMNode => {
  const tr = new Transform(doc);

  const vmType = schema.nodes["viewmodel"];
  const wrapperType = schema.nodes["cards_section"];
  if (!vmType || !wrapperType) return doc;

  const isCardVM = (n: PMNode) =>
    n.type === vmType && n.attrs["type"] === "card";

  let i = 0;
  let pos = 0; // top-level offset

  while (i < tr.doc.childCount) {
    const node = tr.doc.child(i);

    if (!isCardVM(node)) {
      pos += node.nodeSize;
      i += 1;
      continue;
    }

    // gather contiguous run of card VMs starting at i
    let j = i;
    let endPos = pos;
    while (j < tr.doc.childCount && isCardVM(tr.doc.child(j))) {
      endPos += tr.doc.child(j).nodeSize;
      j += 1;
    }

    // wrap cards (works even for a single card)
    const $from = tr.doc.resolve(pos);
    const $to = tr.doc.resolve(endPos);
    const range = $from.blockRange($to);
    const wrap = range ? findWrapping(range, wrapperType) : null;
    if (wrap) {
      tr.wrap(range as NodeRange, wrap);
      // after wrapping, that run is now one node at index i
      pos += tr.doc.child(i).nodeSize;
      i += 1;
    } else {
      // if wrapping wasn't possible, skip past the run
      pos = endPos;
      i = j;
    }
  }

  return tr.doc;
};

export default wrapProsemirrorCardContainer;
